'use client';

import { c as _c } from "react/compiler-runtime";
import { type Post } from '@shared/all/domains/posts';
import usePostEngagementTracker from '@shared/utils/hooks/usePostEngagementTracker';
import React from 'react';
import { useInView } from 'react-intersection-observer';
type Props = {
  post: Post;
  children: React.ReactNode;
};
const PostViewTracker = t0 => {
  const $ = _c(7);
  const {
    post,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      threshold: 0.5,
      triggerOnce: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    ref,
    inView
  } = useInView(t1);
  let t2;
  if ($[1] !== inView || $[2] !== post) {
    t2 = {
      post,
      externalIsInView: inView
    };
    $[1] = inView;
    $[2] = post;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  usePostEngagementTracker(t2);
  let t3;
  if ($[4] !== children || $[5] !== ref) {
    t3 = <div ref={ref}>{children}</div>;
    $[4] = children;
    $[5] = ref;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default PostViewTracker;